<template>
  <a-layout class="buy">
    <TitleBreadcrumb v-if="!isMobile" />
    <div class="content-base container">
      <a-row type="flex" justify="center">
        <a-col class="column-default" :xs="24" :sm="24" :md="24" :lg="18">
          <div class="action-button" ref="actions">
            <span>
              <router-link
                :to="{ name: 'ticket-list' }"
                class="ant-btn ant-btn-default action-button-ticket-list"
              >
                {{ labels.ticketList }}
              </router-link>
              <!-- STATS BUTTON ICON -->
              <a-button
                type="default"
                class="action-button-stats"
                @click="openStatsModal"
                :title="labels.stats.button"
              >
                <a-icon type="bar-chart" />
              </a-button>
            </span>
            <div class="action-button-date">
              <span class="action-button-date-label">{{
                labels.form.date.label
              }}</span>
              <span class="action-button-date-text">{{ form.date }}</span>
            </div>
          </div>
        </a-col>
      </a-row>

      <a-row type="flex" justify="center">
        <a-col :xs="24" :sm="24" :md="24" :lg="18">
          <div class="card-container">
            <!-- BUY -->
            <a-layout class="playing" style="background: transparent">
              <a-layout style="background: transparent">
                <a-layout-content class="content" style="text-align: center">
                  <a-row
                    type="flex"
                    align="middle"
                    class="display-block-mobile"
                  >
                    <a-col
                      class="col-text-ticket form-title-text"
                      style="padding-left: 0px"
                      :lg="24"
                      :md="24"
                      :sm="24"
                    >
                      <div class="selected-lotteries">
                        <span>{{ getStrLotteries }}</span>
                      </div>
                    </a-col>
                  </a-row>
                  <a-row
                    v-if="dataSource.length > 0"
                    :gutter="[24, 24]"
                    type="flex"
                    justify="start"
                    style="margin-bottom: 8px"
                  >
                    <a-col :span="24" :style="{ textAlign: 'right' }">
                      <perfect-scrollbar
                        :options="{
                          wheelPropagation: false,
                          suppressScrollX: true,
                        }"
                        style="max-height: 300px"
                      >
                        <a-table
                          v-if="dataSource.length > 0"
                          :dataSource="dataSource"
                          :pagination="false"
                          :columns="columns"
                          :rowKey="'key'"
                          :size="'small'"
                          :bordered="false"
                          :class="'cart-component-table'"
                          :expandIcon="expandIcon"
                          :rowClassName="
                            (row) =>
                              `table-row ${
                                markedKeys.includes(row.key) ? 'marked' : ''
                              }`.trim()
                          "
                          :expandRowByClick="false"
                          :expandedRowKeys="dataSource.map((item) => item.key)"
                        />
                      </perfect-scrollbar>
                      <!-- TOTALS CARD -->
                      <a-card
                        v-if="dataSource.length > 0"
                        class="totals-card"
                        :style="{ marginTop: '20px' }"
                        :bodyStyle="{ padding: '10px 15px' }"
                        size="small"
                      >
                        <div class="totals">
                          <div class="totals-item">
                            <span class="totals-item-label">{{
                              labels.table.total
                            }}</span>
                            <span class="totals-item-value">{{
                              total | formatNumber(2, ",", ".")
                            }}</span>
                          </div>
                        </div>
                      </a-card>
                    </a-col>
                  </a-row>

                  <a-row
                    v-if="!form.mix && dataSource.length > 0"
                    :gutter="[24, 24]"
                    type="flex"
                    justify="start"
                  >
                    <a-col
                      :span="24"
                      :style="{ textAlign: 'right', marginBottom: '10px' }"
                    >
                      <a-button
                        type="danger"
                        :loading="submitting"
                        :disabled="submitting || !total"
                        class="action-button-clear"
                        ghost
                        @click="handleCleanPlays"
                      >
                        {{ labels.form.clear }}
                      </a-button>
                      <a-button
                        type="primary"
                        :loading="submitting"
                        :disabled="submitting || !total"
                        class="action-button-pay buy-tour-step-1-4"
                        @click="handleSubmit"
                        :title="
                          total ? labels.form.pay : labels.form.clearError
                        "
                      >
                        <a-icon type="check-circle" />
                        {{ labels.form.pay }}
                      </a-button>
                    </a-col>
                  </a-row>
                  <div class="page-content">
                    <div></div>
                    <div class="form-display-1">
                      <a-row :gutter="[24, 24]" type="flex" justify="start">
                        <a-col :xs="18" :sm="18" :lg="18">
                          <div style="display: flex; gap: 10px">
                            <LotteryListCurrent
                              v-model="form.lotteries"
                              v-on:setSuperPale="setSuperPale"
                            />
                            <SuperPaleListCurrent
                              v-model="form.lotteries"
                              v-on:setSuperPale="setSuperPale"
                            />
                          </div>
                        </a-col>
                        <a-col :xs="6" :sm="6" :lg="6">
                          <Autoticket
                            v-on:triggerAutoticket="triggerAutoticket"
                            v-on:handleAddPlay="handleAddPlay"
                          />
                        </a-col>
                      </a-row>

                      <!-- PLAY TYPES -->
                      <a-row
                        :gutter="[12, 12]"
                        type="flex"
                        justify="start"
                        :style="{ margin: 0, paddingTop: '35px' }"
                      >
                        <a-col :xs="24" :md="12" :style="{ padding: '6px 0' }">
                          <a-row :gutter="[12, 12]" type="flex" justify="start">
                            <a-col :span="24">
                              <span class="form-title">{{
                                labels.form.addPlays
                              }}</span>
                            </a-col>
                          </a-row>
                          <div
                            class="play-type-filter buy-tour-step-1-2"
                            :class="{ mini: isMobile }"
                          >
                            <a-radio-group
                              class="custom-radio-button"
                              :default-value="playTypeFilter"
                              button-style="solid"
                              size="large"
                              v-model="playTypeFilter"
                            >
                              <a-radio-button
                                v-if="!superPaleGenerated"
                                :value="PLAY_TYPES.AUTO"
                                >{{
                                  labels.form.playTypes.auto
                                }}</a-radio-button
                              >
                              <a-radio-button
                                v-if="!superPaleGenerated"
                                :value="PLAY_TYPES.QUINIELA"
                              >
                                {{ labels.form.playTypes.quiniela }}
                              </a-radio-button>
                              <a-radio-button
                                v-if="
                                  !superPaleGenerated &&
                                  getFormLotteriesIsSuperquinielaEnabled
                                "
                                :value="PLAY_TYPES.SUPERQUINIELA"
                                class="superquiniela"
                              >
                                {{ labels.form.playTypes.superquiniela }}
                                <a-icon
                                  type="info-circle"
                                  :style="{ marginLeft: '5px' }"
                                  class="custom-icon-info"
                                  @click.stop.prevent="
                                    redirectToSuperquinielaInfo
                                  "
                                  :title="
                                    labels.form.playTypes
                                      .superquinielaDescription
                                  "
                                />
                              </a-radio-button>
                              <a-radio-button :value="PLAY_TYPES.PALE">{{
                                labels.form.playTypes.pale
                              }}</a-radio-button>
                              <a-radio-button
                                v-if="!superPaleGenerated"
                                :value="PLAY_TYPES.TRIPLET"
                              >
                                {{ labels.form.playTypes.tripleta }}
                              </a-radio-button>
                            </a-radio-group>
                          </div>
                        </a-col>
                        <a-col
                          :xs="24"
                          :md="12"
                          :style="{ padding: '6px 0' }"
                          v-if="
                            (getFormLotteriesIsEnabledPick3 ||
                              getFormLotteriesIsEnabledPick4) &&
                            !superPaleGenerated
                          "
                        >
                          <a-row :gutter="[12, 12]" type="flex" justify="start">
                            <a-col :span="24">
                              <span class="form-title">{{
                                labels.form.otherPlays
                              }}</span>
                            </a-col>
                          </a-row>
                          <div
                            class="play-type-filter"
                            :class="{ mini: isMobile }"
                          >
                            <a-radio-group
                              class="custom-radio-button"
                              :default-value="playTypeFilter"
                              button-style="solid"
                              :size="isMobile ? 'default' : 'large'"
                              v-model="playTypeFilter"
                            >
                              <a-radio-button
                                :value="PLAY_TYPES.PICK_3"
                                v-if="getFormLotteriesIsEnabledPick3"
                              >
                                <p style="width: max-content">
                                  {{ labels.form.playTypes.pick3 }}
                                </p>
                              </a-radio-button>
                              <a-radio-button
                                :value="PLAY_TYPES.PICK_4"
                                v-if="getFormLotteriesIsEnabledPick4"
                              >
                                <p style="width: max-content">
                                  {{ labels.form.playTypes.pick4 }}
                                </p>
                              </a-radio-button>
                            </a-radio-group>
                            <a-popover :overlayStyle="{ width: '250px' }">
                              <template slot="content">
                                <p>{{ getFormLotteriesAvailability }}</p>
                              </template>
                              <div class="popover-question">
                                <font-awesome-icon
                                  type="primary"
                                  class="p-0 m-0"
                                  :icon="['fa', 'question']"
                                />
                              </div>
                            </a-popover>
                          </div>
                          <div
                            v-if="
                              playTypeFilter === 'pick3' ||
                              playTypeFilter === 'pick4'
                            "
                            class="prize-of-pick"
                          >
                            <div class="prize-of-pick-title">
                              {{ labels.form.selectMatch }}
                            </div>
                            <a-radio-group v-model="matchType">
                              <a-radio value="straight">
                                {{ labels.form.matchesPick.straight }}
                              </a-radio>
                              <a-radio value="box">
                                {{ labels.form.matchesPick.box }}
                              </a-radio>
                              <div v-if="!matchType" class="danger-error">
                                {{ labels.form.setSelectMatch }}
                              </div>
                            </a-radio-group>
                          </div>
                        </a-col>
                      </a-row>
                      <div class="buy-tour-step-1-3">
                        <form ref="buyTicket" style="display: flex">
                          <a-row
                            type="flex"
                            align="middle"
                            class="display-block-mobile"
                            style="width: 100%"
                          >
                            <a-col :span="24">
                              <AddPlayComponentNewVersion
                                v-if="!form.mix"
                                ref="playComponentNewVersion"
                                :getFormLotteriesIsSuperquinielaEnabled="
                                  getFormLotteriesIsSuperquinielaEnabled
                                "
                                :playTypeFilter="playTypeFilter"
                                :matchType="matchType"
                                :isSuperpale="form.isSuperpale"
                                :superPaleGenerated="superPaleGenerated"
                                :isMobile="isMobile"
                                :labels="labels"
                                :amount="formPlaying.amount"
                                :numbers="formPlaying.numbers"
                                :submitting="submitting"
                                :total="total"
                                @submit="handleAddPlay"
                                @setfocus="setFocus"
                                @onclean="onClean"
                                @handleSubmit="handleSubmit"
                              />
                            </a-col>
                          </a-row>
                        </form>
                        <div class="keyboard-container" ref="keyboardContainer">
                          <div tabindex="-1" class="key-container">
                            <div
                              data-key="1"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              1
                            </div>
                            <div
                              data-key="2"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              2
                            </div>
                            <div
                              data-key="3"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              3
                            </div>
                            <div
                              data-key="{bksp}"
                              tabindex="-1"
                              class="k-btn special-k-btn"
                              @click="onBackspace"
                            >
                              <font-awesome-icon
                                style="font-size: 36px"
                                :icon="['fa', 'backspace']"
                                class="icon-large"
                              />
                            </div>
                            <div
                              data-key="4"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              4
                            </div>
                            <div
                              data-key="5"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              5
                            </div>
                            <div
                              data-key="6"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              6
                            </div>
                            <div
                              data-key="{tab}"
                              tabindex="-1"
                              class="k-btn special-k-btn"
                              @click="focusNumbersInput"
                            >
                              <font-awesome-icon
                                style="font-size: 36px"
                                :icon="['fa', 'arrow-right']"
                                :class="['icon-large', getResponsiveWidth()]"
                              />
                            </div>
                            <div
                              data-key="7"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              7
                            </div>
                            <div
                              data-key="8"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              8
                            </div>
                            <div
                              data-key="9"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              9
                            </div>
                            <div
                              data-key="{combinations}"
                              tabindex="-1"
                              class="k-btn"
                            >
                              <a-popover
                                :open="visiblePopover"
                                trigger="click"
                                overlayClassName="popover-keyboard"
                              >
                                <template #content>
                                  <div
                                    class="popover-pale"
                                    @click="showModalPale"
                                  >
                                    Pale
                                  </div>
                                  <div
                                    class="popover-tripleta"
                                    @click="showModalTripleta"
                                  >
                                    Tripleta
                                  </div>
                                  <div
                                    class="popover-multiple"
                                    @click="showModalMultiple"
                                  >
                                    Pale y Tripleta
                                  </div>
                                </template>
                                <div>Combinaciones</div>
                              </a-popover>
                            </div>
                            <div
                              data-key="{clear}"
                              tabindex="-1"
                              class="k-btn special-k-btn text-xs"
                              @click="onClean"
                            >
                              LIMPIAR
                            </div>
                            <div
                              data-key="0"
                              tabindex="-1"
                              class="k-btn"
                              @click="handleKeyClick"
                            >
                              0
                            </div>
                            <div
                              data-key="{hide}"
                              tabindex="-1"
                              class="k-btn special-k-btn"
                            >
                              <font-awesome-icon
                                style="font-size: 36px"
                                :icon="['fa', 'keyboard']"
                                class="icon-large"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-layout-content>
              </a-layout>
            </a-layout>
          </div>
        </a-col>
      </a-row>

      <a-modal
        v-model="isCombined"
        :title="'Monto'"
        :confirm-loading="confirmLoading"
        @ok="handleOkModalCalculateMixes"
        :cancelText="'Cancelar'"
        :okText="'Ok'"
        class="modal-amount"
      >
        <div class="date-form">
          <Input
            ref="amountCombined"
            :placeholder="'Monto'"
            id="amountCombined"
            size="large"
            :max="99999999999"
            :min="0"
            :rules="'required'"
            :allowClear="true"
            :maxLength="8"
            v-model="formMix.amount"
            :mask="'$####'"
          />
        </div>
      </a-modal>

      <!-- PAYMENT MODAL -->
      <PaymentModal
        v-if="canBuy"
        :dataSource="dataSource"
        :total="total"
        :submitting="submitting"
        :labels="labels"
        :markedKeys="markedKeys"
        @pay="handlePayment"
        @cellChange="onCellChange"
      />

      <!-- SELECT LOTTERIES BY SHARED PLAY MODAL -->
      <ReBuyTicketModal
        :icon="sharedData ? `share-alt` : `reload`"
        :title="
          sharedData
            ? labels.rebuyTicketModal.sharedTitle
            : labels.rebuyTicketModal.rebuyTitle
        "
        :defaultData="sharedData || rebuyData || {}"
        :labels="labels"
        :columns="columns"
        @cancel="redirectToBuy"
        @submit="handleRebuyTicket"
      />

      <!-- MODAL STATS -->
      <StatsModal
        v-if="showStats"
        :visible="showStats"
        :labels="labels.stats"
        @close="showStats = false"
        @addNumbersToPlay="handleAddStatsPlays"
        :lotteries="getStatsLotteries"
      />
    </div>
    <Teleport v-if="authenticated && isBuyPage && isHelperEnable" to="body">
      <a-icon
        title="¡Haz clic aquí para comenzar el recorrido!"
        class="buy-tour-btn"
        type="question-circle"
        @click="handleBuyTour"
        v-if="authenticated && isBuyPage"
      />
    </Teleport>
  </a-layout>
</template>
<script>
import Input from "@/components/core/VeeValidateForm/Input.vue";
import loadingMixin from "@/mixins/loadingMixin";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb";
import LotteryListCurrent from "@/components/LotteryListCurrent";
import SuperPaleListCurrent from "@/components/SuperPaleListCurrent";
import labels from "@/utils/labels";
import {
  DATE_FORMAT,
  generateUniqueID,
  numbersCombinations,
  pageTitle,
  PLAY_TYPES,
} from "../../utils/utils";
import { GET_LOTTERIES } from "@/utils/actions";
import moment from "moment-timezone";
import { mapActions, mapGetters, mapState } from "vuex";
import AddPlayComponentNewVersion from "../../components/AddPlayComponentNewVersion.vue";
import StatsModal from "../../components/StatsModal.vue";
import Teleport from "vue2-teleport";
import EditableCell from "@/components/EditableCell.vue";
import Autoticket from "@/components/Autoticket.vue";
import * as _ from "lodash";
import PaymentModal from "@/components/BuyPaymentModal.vue";
import ReBuyTicketModal from "@/components/ReBuyTicketModal.vue";
import EventBus, { ListEvents } from "../../event";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { isEqual } from "lodash";
import tour2 from "@/assets/images/tour/tour-2.svg";
import tour3 from "@/assets/images/tour/tour-3.svg";

const initialState = {
  date: moment().format(DATE_FORMAT.MOMENT_DATE),
  lotteries: [],
  isSuperpale: false,
  mix: false,
  details: [],
  sharedBy: null,
  sharedTicket: null,
};

export default {
  components: {
    TitleBreadcrumb,
    LotteryListCurrent,
    SuperPaleListCurrent,
    AddPlayComponentNewVersion,
    PaymentModal,
    ReBuyTicketModal,
    Input,
    Autoticket,
    Teleport,
    StatsModal,
  },
  mixins: [loadingMixin],
  name: "Buy",
  metaInfo: {
    title: pageTitle(labels.playNow.title),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.buy.title,
      },
    ],
  },
  data() {
    return {
      labels: { ...labels.buy },
      PLAY_TYPES,
      playTypeFilter: PLAY_TYPES.AUTO,
      form: _.cloneDeep(initialState),
      formPlaying: { amount: "0", numbers: "", amountCombined: "0" },
      formMix: {
        numbers: [],
        amount: 0,
      },
      submitting: false,
      sharedData: null,
      rebuyData: null,
      markedKeys: [],

      // New Version Cart
      ticketsBuy: [],
      isFocus: "",
      isCombined: false,
      isPale: false,
      isTripleta: false,
      isFocusNumbers: false,
      ticketsBuyQuintiles: [],
      confirmLoading: false,
      visiblePopover: false,
      superPaleGenerated: false,

      cartByParam: false,

      matchType: "straight",
      showStats: false,
    };
  },
  filters: {
    hourToMilliseconds(value) {
      const date = moment(value, DATE_FORMAT.MOMENT_TIME);
      return date.diff(moment(), "milliseconds", true);
    },
    countDownFormat(value) {
      if (value < 0) {
        return "--";
      }
      return value.toString().padStart(2, "0");
    },
  },
  computed: {
    ...mapState("clientAuth", ["authenticated"]),
    ...mapGetters({
      loggedUser: "clientAuth/getLoggedUser",
      getStrLotteries: "lotteries/getStrLotteries",
      isGettingLoggedUser: "clientAuth/isGettingLoggedUser",
      isHelperEnable: "systemConfig/getIsHelperEnable",
    }),
    getStatsLotteries() {
      return this.$refs?.lotteries?.getDataSource() || [];
    },
    getFormLotteries: {
      get() {
        let lotteries = _.cloneDeep(this.form.lotteries);
        lotteries.forEach((element, index) => {
          if (element?.type && element.type === PLAY_TYPES.SUPERPALE) {
            lotteries.splice(index, 1);
          }
        });
        return lotteries;
      },
      set(value) {
        this.form.lotteries = value;
      },
    },
    getFormLotteriesIsEnabledPick3: {
      get() {
        let lotteries = _.cloneDeep(this.form.lotteries);
        let isEnabled = false;
        lotteries.forEach((element) => {
          if (element.active_pick3) {
            isEnabled = true;
          }
        });
        return isEnabled;
      },
    },
    getFormLotteriesIsEnabledPick4: {
      get() {
        let lotteries = _.cloneDeep(this.form.lotteries);
        let isEnabled = false;
        lotteries.forEach((element) => {
          if (element.active_pick4) {
            isEnabled = true;
          }
        });
        return isEnabled;
      },
    },
    getFormLotteriesAvailability: {
      get() {
        let lotteries = _.cloneDeep(this.form.lotteries);
        let textPick3 = "";
        let textPick4 = "";
        lotteries.forEach((element) => {
          if (element.active_pick3) {
            textPick3 = "Pick 3 disponible en ";
            textPick3 = textPick3 + element.name + ", ";
            if (textPick3 !== "Pick 3 disponible en ") {
              textPick3 = textPick3.slice(0, -2);
            } else {
              textPick3 = "";
            }
          }
          if (element.active_pick4) {
            textPick4 = "Pick 4 disponible en ";
            textPick4 = textPick4 + element.name + ", ";
            if (textPick4 !== "Pick 4 disponible en ") {
              textPick4 = textPick4.slice(0, -2);
            } else {
              textPick4 = "";
            }
          }
        });
        return textPick3 + ". " + textPick4;
      },
    },
    total() {
      return _.sumBy(_.cloneDeep(this.form.details), (play) =>
        Number(play.amount)
      );
    },
    canBuy() {
      return this.loggedUser?.balance >= this.total;
    },
    showSuperpale() {
      return this.form.lotteries.length >= 2;
    },
    isMobile() {
      return this.screenWidth <= 767;
    },
    columns() {
      return [
        {
          title: this.labels.table.play,
          dataIndex: "type",
          key: "type",
          width: "35%",
          customRender: (text, record) => {
            if (record?.isLottery) {
              const lotteryName = record.secondLottery?.id
                ? `${record.lottery.name} - ${record.secondLottery.name}`
                : record.lottery.name;
              return {
                children: <span class="text-hover">{lotteryName}</span>,
                attrs: {
                  colSpan: 4,
                },
              };
            }
            return (
              this.labels.form.playTypes[text] ||
              this.$options.filters.ucfirst(text)
            );
          },
        },
        {
          title: this.labels.table.numbers,
          dataIndex: "numbers",
          key: "numbers",
          width: "25%",
          align: "center",
          customRender: (numbers, record) => {
            if (record.isLottery) {
              return {
                attrs: {
                  colSpan: 0,
                },
              };
            }
            if (record.straight_match === record.box_match) {
              record.straight_match = true;
              record.box_match = false;
            }

            const text =
              record.type === PLAY_TYPES.PICK_3 ||
              record.type === PLAY_TYPES.PICK_4
                ? record.straight_match
                  ? "(Straight)"
                  : record.box_match
                  ? "(Box)"
                  : ""
                : "";
            return numbers + ` ${text} `;
          },
        },
        {
          title: this.labels.table.amount,
          dataIndex: "amount",
          key: "amount",
          width: "30%",
          align: "right",
          customRender: (amount, record) => {
            if (record.isLottery) {
              return {
                attrs: {
                  colSpan: 0,
                },
              };
            }
            // editable cell
            return {
              children: (
                <EditableCell
                  modelValue={amount}
                  onChange={(value) =>
                    this.onCellChange(record.key, "amount", value)
                  }
                />
              ),
            };
          },
        },
        {
          title: "",
          dataIndex: "action",
          key: "action",
          width: "10%",
          align: "center",
          customRender: (_, record) => {
            return record.isLottery ? (
              {
                attrs: {
                  colSpan: 0,
                },
              }
            ) : (
              <div>
                <a-tooltip
                  overlayClassName={"custom-tooltip-danger"}
                  title={this.labels.table.action.remove}
                  placement={"right"}
                >
                  <a-button
                    disabled={this.deleting}
                    type="link"
                    size="small"
                    class="btn-remove"
                    onClick={() => this.handleRemove(record)}
                    icon="delete"
                    style={{ color: "#f5222d" }}
                  />
                </a-tooltip>
              </div>
            );
          },
        },
      ];
    },
    dataSource() {
      return Object.values(
        _.cloneDeep(this.form.details).reduce((acc, val) => {
          const lottery = val.lottery;
          const isSuperpale = val.type === PLAY_TYPES.SUPERPALE;
          const secondLottery = val.secondLottery || null;
          const key =
            isSuperpale && secondLottery
              ? `${lottery.id}-${secondLottery.id}`
              : lottery.id;
          if (!acc[key]) {
            acc[key] = {
              key: this.uuid(),
              lottery,
              ...(isSuperpale ? { secondLottery } : {}),
              isLottery: true,
              children: [],
            };
          }
          acc[key].children.push(val);
          return acc;
        }, {})
      );
    },
    getFormLotteriesIsSuperquinielaEnabled: {
      get() {
        let lotteries = _.cloneDeep(this.form.lotteries);
        let isEnabled = false;
        lotteries.forEach((element) => {
          if (element.superquiniela_enabled) {
            isEnabled = true;
          }
        });
        return isEnabled;
      },
    },
    ajm() {
      return this.loggedUser?.ajm || false;
    },
    isBuyPage() {
      return this.$route.name === "buy";
    },
  },
  methods: {
    ...mapActions("buy", [
      "fetchLotteries",
      "processTicket",
      "decodeUrlForCart",
    ]),
    ...mapActions("shortUrl", ["getShortUrl"]),
    ...mapActions("clientAuth", ["updateSettings"]),
    setPlayTypeFilter(value) {
      this.playTypeFilter = value;
    },
    triggerAutoticket(playTotals, monto) {
      console.log("values:", playTotals, monto);
    },
    setSuperPale(value) {
      this.superPaleGenerated = value;
    },
    redirectToSuperquinielaInfo() {
      window.open(
        "https://drive.google.com/file/d/1PaAHQaCamYJVxmQepvJNttUKLi_F4yE6/view?usp=drive_link",
        "_blank"
      );
    },
    getLotteryEndTime(lottery) {
      const lotteryEndTime = moment
        .tz(
          lottery.today_end_time,
          DATE_FORMAT.SERVER_TIME,
          lottery.timezone || DATE_FORMAT.TIMEZONE
        )
        .tz(DATE_FORMAT.TIMEZONE)
        .format(DATE_FORMAT.MOMENT_TIME);
      return lotteryEndTime;
    },
    handleOkModalCalculateMixes() {
      const mixes = [];

      // MIX PLAYS BY QUINIELA
      let value = parseInt(this.formMix.amount.substring(1));
      if (value > 0) {
        _.cloneDeep(
          this.form.details.filter(
            (element) => element.type == PLAY_TYPES.QUINIELA
          )
        ).forEach((number) => {
          const found = mixes.find((item) => item.numbers === number);
          if (!found) {
            mixes.push({
              numbers: number.numbers,
              amount: number.amount,
              type: PLAY_TYPES.QUINIELA,
            });
          }
        });
      }

      // MIX PLAYS BY PAIRS
      if (this.isPale) {
        let value = parseInt(this.formMix.amount.substring(1));
        const numbers = this.form.details.filter(
          (element) => element.type == PLAY_TYPES.QUINIELA
        );
        if (numbers.length >= 2 && value > 0) {
          _.cloneDeep(numbers).forEach((number, index) => {
            _.cloneDeep(numbers).forEach((number2, index2) => {
              const found = mixes.find(
                (item) =>
                  item.numbers === `${number.numbers}-${number2.numbers}` ||
                  item.numbers === `${number2.numbers}-${number.numbers}`
              );
              if (!found && index !== index2) {
                mixes.push({
                  numbers: `${number.numbers}-${number2.numbers}`,
                  amount: value,
                  amountSuperpale: 0,
                  type: PLAY_TYPES.PALE,
                });
              }
            });
          });
        }
      }

      // MIX PLAYS BY TRIPLETS
      if (this.isTripleta) {
        let value = parseInt(this.formMix.amount.substring(1));
        const numbers = this.form.details.filter(
          (element) => element.type == PLAY_TYPES.QUINIELA
        );
        if (numbers.length >= 3 && value > 0) {
          _.cloneDeep(numbers).forEach((number, index) => {
            _.cloneDeep(numbers).forEach((number2, index2) => {
              _.cloneDeep(numbers).forEach((number3, index3) => {
                const found = mixes.find(
                  (item) =>
                    item.numbers ===
                      `${number.numbers}-${number2.numbers}-${number3.numbers}` ||
                    item.numbers ===
                      `${number.numbers}-${number3.numbers}-${number2.numbers}` ||
                    item.numbers ===
                      `${number2.numbers}-${number.numbers}-${number3.numbers}` ||
                    item.numbers ===
                      `${number2.numbers}-${number3.numbers}-${number.numbers}` ||
                    item.numbers ===
                      `${number3.numbers}-${number.numbers}-${number2.numbers}` ||
                    item.numbers ===
                      `${number3.numbers}-${number2.numbers}-${number.numbers}`
                );
                if (!found && index !== index2 && index !== index3) {
                  mixes.push({
                    numbers: `${number.numbers}-${number2.numbers}-${number3.numbers}`,
                    amount: value,
                    type: PLAY_TYPES.TRIPLET,
                  });
                }
              });
            });
          });
        }
      }

      this.confirmLoading = true;
      setTimeout(() => {
        this.isCombined = false;
        this.confirmLoading = false;

        if (mixes.length > 0) {
          // UNIQUE MIXES BY TYPE AND NUMBERS
          let newMixes = mixes.reduce((acc, current) => {
            const combinations = numbersCombinations(current.numbers);
            const foundIndex = acc.findIndex(
              (item) =>
                item.type === current.type &&
                combinations.includes(item.numbers)
            );
            if (foundIndex === -1) {
              acc.push(current);
            }
            return acc;
          }, []);

          this.handleAddMixesPlays(newMixes);
        }
      }, 2000);
    },
    handleKeyClick(event) {
      const key = event.target.getAttribute("data-key");

      if ((this.isFocus != "amount") & (this.isFocus != "play")) {
        this.isFocus = "amount";
      }

      if (this.isFocus == "play") {
        if (!this.formPlaying.numbers) {
          this.formPlaying.numbers = key;
        } else {
          this.formPlaying.numbers += key;
        }
      } else {
        if (this.formPlaying.amount == "0") {
          this.formPlaying.amount = key;
        } else {
          this.formPlaying.amount += key;
        }
      }
    },
    setFocus(value) {
      this.isFocus = value;
    },
    onBackspace() {
      if ((this.isFocus != "amount") & (this.isFocus != "play")) {
        this.isFocus = "amount";
      }

      if (this.isFocus == "play") {
        const numbers = this.formPlaying.numbers;
        let newValue = numbers.substring(0, numbers.length - 1);
        if (newValue.substring(newValue.length - 1, newValue.length) == "-") {
          newValue = newValue.substring(0, newValue.length - 1);
        }
        this.formPlaying.numbers = newValue;
      } else {
        const amount = this.formPlaying.amount;
        if (amount.length > 2) {
          const newValue = amount.substring(0, amount.length - 1);
          this.formPlaying.amount = newValue;
        } else {
          this.formPlaying.amount = "0";
        }
      }
    },
    focusNumbersInput() {
      if (this.isFocus == "play") {
        this.isFocus = "amount";
        if (this.$refs.playComponentNewVersion)
          this.$refs.playComponentNewVersion.focusAmount();
      } else {
        this.isFocus = "play";
        if (this.$refs.playComponentNewVersion)
          this.$refs.playComponentNewVersion.focusNumbers();
      }
    },
    getResponsiveWidth() {
      return this.isFocus == "play" ? "" : "form-rotate";
    },
    showModalPale() {
      if (
        this.form.details.filter(
          (element) => element.type === PLAY_TYPES.QUINIELA
        ).length >= 2
      ) {
        this.isCombined = true;
        this.isPale = true;
        this.isTripleta = false;
        this.visiblePopover = false;
      } else {
        this.$notification.error({
          message: this.labels.mixPaleError,
          description: this.labels.nonRepeated2Pools,
        });
      }
    },
    showModalTripleta() {
      if (
        this.form.details.filter(
          (element) => element.type === PLAY_TYPES.QUINIELA
        ).length >= 3
      ) {
        this.isCombined = true;
        this.isPale = false;
        this.isTripleta = true;
        this.visiblePopover = false;
      } else {
        this.$notification.error({
          message: this.labels.mixTripletaError,
          description: this.labels.nonRepeated3Pools,
        });
      }
    },
    showModalMultiple() {
      if (
        this.form.details.filter(
          (element) => element.type === PLAY_TYPES.QUINIELA
        ).length >= 3
      ) {
        this.isCombined = true;
        this.isPale = true;
        this.isTripleta = true;
        this.visiblePopover = false;
      } else {
        this.$notification.error({
          message: this.labels.mixPaleTripletaError,
          description: this.labels.nonRepeated3Pools,
        });
      }
    },
    onClean() {
      this.formPlaying.amount = "0";
      this.formPlaying.numbers = "";
      this.isPale = false;
      this.isTripleta = false;
      this.ticketsBuy = [];
      this.ticketsBuyQuintiles = [];
    },
    changeSelectPagination(value) {
      this.$store.commit("lotteries/" + GET_LOTTERIES, value);
    },
    markRows(errors = []) {
      this.markedKeys = errors.reduce((acc, val) => {
        if (!val.includes("->")) return acc;
        const index = parseInt(val.split("->")[0].replace(/\D/g, ""));
        if (!isNaN(index)) acc.push(this.form.details[index].key);
        return acc;
      }, []);
    },
    scrollIntoView(ref) {
      if (ref) {
        if (ref.$el)
          ref.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        else ref.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    uuid() {
      return generateUniqueID();
    },
    expandIcon({ expandable }) {
      return expandable ? "" : " ";
    },
    countRecordByLottery(lottery, secondLottery = null) {
      if (secondLottery?.id) {
        return _.cloneDeep(this.form.details).filter(
          (detail) =>
            detail.lottery.id === lottery.id &&
            detail.secondLottery?.id &&
            detail.secondLottery.id === secondLottery.id
        ).length;
      }
      return _.cloneDeep(this.form.details).filter(
        (detail) => detail.lottery.id === lottery.id && !detail.secondLottery
      ).length;
    },
    groupedDatails(data = []) {
      return data.reduce((acc, val) => {
        if (val.type === PLAY_TYPES.PICK_3 || val.type === PLAY_TYPES.PICK_4) {
          return acc;
        }
        const combinations = numbersCombinations(val.numbers);
        let foundIndex = acc.findIndex((item) => {
          if (
            !(
              item.type === val.type &&
              item.lottery.id === val.lottery.id &&
              combinations.includes(item.numbers)
            )
          ) {
            return false;
          }

          if (
            val.secondLottery &&
            !(item.secondLottery.id === val.secondLottery.id)
          ) {
            return false;
          }

          return true;
        });

        if (foundIndex !== -1) {
          acc[foundIndex].amount += val.amount;
        } else {
          acc.push(val);
        }

        return acc;
      }, []);
    },
    groupedDatailsPick(data = []) {
      return data.reduce((acc, val) => {
        const combinations = numbersCombinations(val.numbers);
        let foundIndexOK = -1;

        if (val.straight_match) {
          let exist = acc.findIndex(
            (item1) =>
              item1.type === val.type &&
              item1.straight_match &&
              item1.numbers === val.numbers
          );
          if (exist !== -1) {
            foundIndexOK = exist;
          } else {
            foundIndexOK = -1;
          }
        } else if (val.box_match) {
          let exist = acc.findIndex(
            (item) =>
              item.type === val.type &&
              item.box_match === val.box_match &&
              combinations.includes(item.numbers)
          );
          if (exist !== -1) {
            foundIndexOK = exist;
          } else {
            foundIndexOK = -1;
          }
        }

        if (foundIndexOK !== -1) {
          acc[foundIndexOK].amount += val.amount;
        } else {
          acc.push(val);
        }

        return acc;
      }, []);
    },
    async handleSubmit() {
      try {
        if (this.canBuy) {
          EventBus.$emit(ListEvents.open_payment_modal);
        } else {
          this.$notification.error({
            message: this.labels.payError,
            description: this.labels.insufficientBalance,
          });
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async handleAddMixesPlays(data) {
      try {
        const isvalid = await this.$refs.buyObserver.validate();
        if (!isvalid && !this.form.lotteries.length) {
          this.$notification.error({
            message: this.labels.form.lotteries.label,
            description: this.labels.form.lotteries.required,
            onClose: () => {
              this.$refs.lotteries.$el.querySelector("input").focus();
            },
          });
          return;
        }

        if (isvalid) {
          const details = [
            ..._.cloneDeep(this.form.lotteries).reduce((acc, lottery) => {
              const dataDetails = _.cloneDeep(data)
                .filter(({ type }) => type !== PLAY_TYPES.SUPERPALE)
                .map((item) => ({
                  ...item,
                  numbers: this.normalizeNumbers(item.numbers),
                  key: this.uuid(),
                  lottery: {
                    id: lottery.id,
                    name: lottery.name,
                    abbreviated: lottery.abbreviated,
                    today_end_time: lottery.today_end_time,
                  },
                }));
              return [...acc, ...dataDetails];
            }, []),
          ];

          // MIX MIX LOTTERIES FOR SUPERPALE
          if (this.form.lotteries.length > 1 && this.form.isSuperpale) {
            const mixesLotteries = _.cloneDeep(this.form.lotteries).reduce(
              (acc, lottery) => {
                this.form.lotteries.forEach((secondLottery) => {
                  if (lottery.id !== secondLottery.id) {
                    const found = acc.find(
                      (item) =>
                        (item.lottery.id === lottery.id &&
                          item.secondLottery.id === secondLottery.id) ||
                        (item.lottery.id === secondLottery.id &&
                          item.secondLottery.id === lottery.id)
                    );
                    if (!found) {
                      acc.push({
                        lottery: {
                          id: lottery.id,
                          name: lottery.name,
                          abbreviated: lottery.abbreviated,
                          today_end_time: lottery.today_end_time,
                        },
                        secondLottery: {
                          id: secondLottery.id,
                          name: secondLottery.name,
                          abbreviated: secondLottery.abbreviated,
                          today_end_time: secondLottery.today_end_time,
                        },
                        key: this.uuid(),
                      });
                    }
                  }
                });
                return acc;
              },
              []
            );

            // ADD PLAYS
            mixesLotteries.forEach((item) => {
              _.cloneDeep(data)
                .filter(({ type }) =>
                  [PLAY_TYPES.PALE, PLAY_TYPES.SUPERPALE].includes(type)
                )
                .forEach((play) => {
                  const amount = play?.amountSuperpale || play?.amount;
                  delete play.amountSuperpale;
                  details.push({
                    ...play,
                    ...item,
                    numbers: this.normalizeNumbers(play.numbers),
                    amount,
                    key: this.uuid(),
                    type: PLAY_TYPES.SUPERPALE,
                  });
                });
            });
          }

          this.form.details = this.groupedDatails([
            ...this.form.details,
            ...details,
          ]);

          // SET MIX TO FALSE
          this.form.mix = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleAddPlay(data) {
      try {
        let details = [];
        // Validar superpale generado en la version 2 del carrito
        if (
          this.superPaleGenerated &&
          this.form.lotteries &&
          this.form.lotteries.length > 0
        ) {
          this.form.lotteries.forEach((element) => {
            if (element.type == PLAY_TYPES.SUPERPALE) {
              this.form.details.push({
                ...data,
                numbers: this.normalizeNumbers(data.numbers),
                lottery: {
                  id: element.lottery.id,
                  name: element.lottery.name,
                  abbreviated: element.lottery.abbreviated,
                  today_end_time: element.lottery.today_end_time,
                },
                secondLottery: {
                  id: element.secondLottery.id,
                  name: element.secondLottery.name,
                  abbreviated: element.secondLottery.abbreviated,
                  today_end_time: element.secondLottery.today_end_time,
                },
                type: element.type,
                key: this.uuid(),
              });
            }
          });
        } else {
          if (!this.cartByParam) {
            if (!this.form.lotteries.length) {
              this.$notification.error({
                message: this.labels.form.lotteries.label,
                description: this.labels.form.lotteries.required,
              });
              return;
            }
          } else {
            if (!this.form.lotteries.length) {
              this.$notification.error({
                message: this.labels.form.lotteries.label,
                description: this.labels.form.lotteries.required,
              });
              return;
            }
          }

          const lotteryCount = this.form.lotteries.length;
          if (this.form.isSuperpale) {
            if (lotteryCount < 2) {
              this.$notification.error({
                message: this.labels.form.lotteries.label,
                description: this.labels.form.lotteries.min(2),
              });
              return;
            }

            // LOTTERIES MIX
            this.form.lotteries.forEach((lottery, index) => {
              this.form.lotteries.forEach((secondLottery, index2) => {
                const found = details.find(
                  (item) =>
                    (item.lottery.id === lottery.id &&
                      item.secondLottery.id === secondLottery.id) ||
                    (item.lottery.id === secondLottery.id &&
                      item.secondLottery.id === lottery.id)
                );
                if (!found && index !== index2) {
                  details.push({
                    lottery: lottery,
                    secondLottery: secondLottery,
                  });
                }
              });
            });

            // GENERATE PLAYS
            details = details.map((item) => ({
              ...data,
              numbers: this.normalizeNumbers(data.numbers),
              lottery: {
                id: item.lottery.id,
                name: item.lottery.name,
                abbreviated: item.lottery.abbreviated,
                today_end_time: item.lottery.today_end_time,
              },
              secondLottery: {
                id: item.secondLottery.id,
                name: item.secondLottery.name,
                abbreviated: item.secondLottery.abbreviated,
                today_end_time: item.secondLottery.today_end_time,
              },
            }));
          } else {
            // MIX PLAYS
            this.form.lotteries.forEach((lottery) => {
              const found = details.find(
                (item) =>
                  !item.secondLottery &&
                  this.normalizeNumbers(item.numbers) ===
                    this.normalizeNumbers(data.numbers) &&
                  item.type === data.type &&
                  item.lottery.id === lottery.id
              );
              if (!found) {
                if (
                  (data.type === PLAY_TYPES.PICK_3 && lottery.active_pick3) ||
                  (data.type === PLAY_TYPES.PICK_4 && lottery.active_pick4)
                ) {
                  details.push({
                    ...data,
                    numbers: data.numbers,
                    lottery: {
                      id: lottery.id,
                      name: lottery.name,
                      abbreviated: lottery.abbreviated,
                      today_end_time: lottery.today_end_time,
                    },
                  });
                } else if (
                  [
                    PLAY_TYPES.QUINIELA,
                    PLAY_TYPES.PALE,
                    PLAY_TYPES.TRIPLET,
                    PLAY_TYPES.SUPERPALE,
                    PLAY_TYPES.SUPERQUINIELA,
                  ].includes(data.type)
                ) {
                  if (
                    data.type === PLAY_TYPES.SUPERQUINIELA &&
                    !lottery.superquiniela_enabled
                  ) {
                    return;
                  }

                  details.push({
                    ...data,
                    numbers: this.normalizeNumbers(data.numbers),
                    lottery: {
                      id: lottery.id,
                      name: lottery.name,
                      abbreviated: lottery.abbreviated,
                      today_end_time: lottery.today_end_time,
                    },
                  });
                }
              }
            });
          }

          // ADD PLAYS IF NOT EXIST
          if (
            data.type === PLAY_TYPES.PICK_3 ||
            data.type === PLAY_TYPES.PICK_4
          ) {
            this.form.details = this.groupedDatailsPick([
              ...this.form.details,
              ...details.map((item) => ({
                ...item,
                key: this.uuid(),
              })),
            ]);
          } else {
            this.form.details = this.groupedDatails([
              ...this.form.details,
              ...details.map((item) => ({
                ...item,
                key: this.uuid(),
              })),
            ]);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleAddStatsPlays(data = []) {
      try {
        const lotteriesToAdd = [];
        _.cloneDeep(data).map((item) => {
          const foundIndex = this.form.details.findIndex(
            (curr) =>
              curr.lottery.id === item.lottery.id &&
              curr.numbers === item.numbers &&
              curr.type === item.type
          );
          if (foundIndex !== -1) {
            this.form.details[foundIndex].amount += item.amount;
            this.form.details = [...this.form.details];
          } else {
            this.form.details.push({
              ...item,
              numbers: this.normalizeNumbers(item.numbers),
              lottery: {
                id: item.lottery.id,
                name: item.lottery.name,
                abbreviated: item.lottery.abbreviated,
                today_end_time: item.lottery.today_end_time,
              },
              key: this.uuid(),
            });
          }

          const foundLotteryIndex = _.cloneDeep(
            this.getFormLotteries
          ).findIndex((lottery) => lottery.id === item.lottery.id);
          if (foundLotteryIndex === -1) {
            lotteriesToAdd.push(item.lottery);
          }
        });

        if (lotteriesToAdd.length) {
          this.form.lotteries = _.cloneDeep([
            ...this.getFormLotteries,
            ...lotteriesToAdd,
          ]);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleRemove(record) {
      const details = _.cloneDeep(this.form.details);
      const index = details.findIndex(
        (item) =>
          item.lottery.id === record.lottery.id &&
          item.numbers === record.numbers &&
          item.type === record.type &&
          item.secondLottery?.id === record.secondLottery?.id
      );
      if (index !== -1) {
        details.splice(index, 1);
        this.form.details = details;
      }
    },
    handleCleanPlays() {
      this.form.details = [];
    },
    async handlePayment(formData) {
      try {
        this.submitting = true;
        this.markedKeys = [];
        const { message, data } = await this.processTicket({
          date: moment().format("YYYY-MM-DD HH:mm:ss"),
          details: _.cloneDeep(formData),
          total: this.total,
          sharedBy: this.form.sharedBy,
          sharedTicket: this.form.sharedTicket,
        });
        this.$confirm({
          title: this.labels.payment.success || message,
          centered: false,
          class: "success-payment-modal",
          // JSX support
          content: (
            <div style="display:block;width:100%;">
              <span style="font-weight:bold;font-size:16px;">
                {this.labels.payment.ticketLabel}
              </span>
              <span style="font-weight:bold;font-size:16px;">
                {data.number}
              </span>
            </div>
          ),
          cancelText: this.labels.success.cancelText,
          okText: this.labels.success.okText,
          okType: "primary",
          autoFocusButton: "cancel",
          onCancel: async () => {
            // GET USER BALANCE
            await this.$store.dispatch("clientAuth/checkSession");
            EventBus.$emit(ListEvents.close_payment_modal);
            this.cleanData();
          },
          onOk: async () => {
            // GET USER BALANCE
            await this.$store.dispatch("clientAuth/checkSession");
            EventBus.$emit(ListEvents.close_payment_modal);
            this.cleanData();
            this.$router.push({
              name: "ticket-view",
              params: { code: data.number },
            });
          },
        });
      } catch (error) {
        if (error.isAxiosError && [401, 403].includes(error.response.status)) {
          EventBus.$emit(ListEvents.close_payment_modal);
          this.$router.push({ name: "login" });
        } else if (error.isAxiosError && error.response.status === 400) {
          if (error.response?.data?.additional_errors?.length) {
            this.markRows(error.response.data.additional_errors);
          }
          const key = `open${Date.now()}`;
          this.$notification["error"]({
            message: error?.response?.data?.message || labels.formError,
            duration: 0,
            key,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.map((err) => {
                  return h("li", err.includes("->") ? err.split("->")[1] : err);
                })
              );
            },
            btn: (h) => {
              return h(
                "a-button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => this.$notification.close(key),
                  },
                },
                "Ok"
              );
            },
          });
        } else {
          this.$notification["error"]({
            message:
              error?.response?.data?.message ||
              error?.message ||
              labels.unknownServerError,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    cleanData() {
      this.form = _.cloneDeep(initialState);
    },
    openRebuyTicketModal() {
      this.$nextTick(() => {
        EventBus.$emit(ListEvents.open_rebuy_ticket_modal);
      });
    },
    redirectToBuy() {
      this.$router.push({ name: "buy" });
    },
    handleRebuyTicket(data) {
      Object.assign(this.form, {
        lotteries: data.lotteries,
        sharedBy: data.sharedBy,
        sharedTicket: data.sharedTicket,
        details: data.details,
      });
    },
    processQuery(query) {
      const secret = process.env.VUE_APP_CRYTO_KEY;
      if (query && secret) {
        let data = null;
        try {
          data = JSON.parse(
            window.atob(
              this.$CryptoJS.AES.decrypt(
                query.replace(/\s/g, "+"),
                secret
              )?.toString(this.$CryptoJS.enc.Utf8)
            )
          );
        } catch (error) {
          console.error(error);
        }
        if (data?.details?.length) {
          this.rebuyData = data;
          this.openRebuyTicketModal();
        }
      }
    },
    async processRebuy(UUID) {
      try {
        this.loading = true;
        const { data: resData } = await this.getShortUrl(UUID);
        const ticket = JSON.parse(window.atob(resData.url));
        this.rebuyData = ticket;
        this.openRebuyTicketModal();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message ||
            this.labels.sharedError
        );
      } finally {
        this.loading = false;
      }
    },
    async processShared(UUID) {
      try {
        this.loading = true;
        const { data: resData } = await this.getShortUrl(UUID);
        const ticket = JSON.parse(window.atob(resData.url));
        this.sharedData = ticket;
        this.openRebuyTicketModal();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message ||
            this.labels.sharedError
        );
      } finally {
        this.loading = false;
      }
    },
    onCellChange(key, dataIndex, value) {
      const dataSource = _.cloneDeep(this.form.details);
      const foundIndex = dataSource.findIndex((item) => item.key === key);
      if (foundIndex > -1) {
        dataSource[foundIndex][dataIndex] = value;
        this.form.details = dataSource;
        if (this.markedKeys.includes(key)) {
          this.markedKeys = this.markedKeys.filter((val) => val !== key);
        }
      }
    },
    // Decode the URL in the backend and extract the plays
    async decodeParam(d) {
      try {
        const decodeUrl = await this.decodeUrlForCart({ d: d });
        const { data: data } = await this.fetchLotteries();
        const lotteries = data.data;
        decodeUrl.forEach((element) => {
          element.lotteries.forEach((lotteryId) => {
            const foundLottery = lotteries.find(
              (lottery) => lottery.id == lotteryId
            );
            if (!foundLottery) {
              this.$notification.error({
                message: this.labels.form.lotteries.label,
                description: this.labels.form.lotteries.outOfTime,
              });
            } else {
              this.form.lotteries.push(foundLottery);
            }
            // Possibility of defining superpales
            //this.form.isSuperpale = true;
          });

          this.cartByParam = true;
          const arrayPlay = element.bet.split("-");
          if (this.form.lotteries.length > 0) {
            const amount =
              typeof element.amount === "number" && !isNaN(element.amount)
                ? element.amount
                : 0;

            if (amount > 0) {
              this.handleAddPlay({
                numbers: element.bet,
                amount: element.amount,
                type:
                  arrayPlay.length === 3
                    ? PLAY_TYPES.TRIPLET
                    : arrayPlay.length === 2
                    ? PLAY_TYPES.PALE
                    : arrayPlay.length === 1 &&
                      element.type === PLAY_TYPES.SUPERQUINIELA
                    ? PLAY_TYPES.SUPERQUINIELA
                    : PLAY_TYPES.QUINIELA,
              });
            }
          }

          this.form.lotteries.splice(0, this.form.lotteries.length);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.cartByParam = false;
      }
    },
    handleBuyTour() {
      if (!this.isHelperEnable) return;
      const { firstname, lastname, settings = {} } = this.loggedUser;
      const driverObj = driver({
        nextBtnText: "Siguiente",
        prevBtnText: "Anterior",
        doneBtnText: "Terminar",
        showProgress: true,
        steps: [
          {
            popover: {
              title: `<img class="tour-image" src="${tour2}"/>¡Hola, ${
                firstname || ""
              } ${lastname || ""}!`,
              description: `<b>En esta sección encontrarás los distintos tipos de apuestas disponibles.</b><br/><br/>Te guiaré paso a paso para que conozcas cómo realizar tus jugadas de forma rápida y segura.`,
              side: "top",
            },
          },
          {
            element: ".buy-tour-step-1-1",
            popover: {
              title: "🎯 Paso 1: Selecciona la(s) lotería(s)",
              description:
                "<b>Elige las loterías en las que deseas jugar:</b> Anguila, King Lottery Noche, Loteka. ¡Y mucho más!",
              side: "left",
              align: "start",
            },
          },
          {
            element: ".buy-tour-step-1-2",
            popover: {
              title: "🎲 Paso 2: Elige tu tipo de jugada",
              description:
                "<b>Puedes seleccionar entre:</b><br/><br/><ul><li>Quiniela</li><li>Súper Quiniela</li><li>Palé</li><li>Súper Palé</li><li>Tripleta</li><li>¡Y nuestros autickets especiales!</li></ul>",
            },
            side: "left",
            align: "start",
          },
          {
            element: ".buy-tour-step-1-3",
            popover: {
              title: "🔢 Paso 3: Ingresa tu jugada",
              description:
                "Escribe los números que quieres apostar y define el monto de tu jugada.",
            },
            side: "left",
            align: "start",
          },
          {
            element: ".buy-tour-step-1-4",
            popover: {
              title: "➕ Paso 4: Añade y paga tu ticket",
              description:
                "Haz clic en el botón + para añadir tu jugada al carrito. Luego, presiona <b>“Pagar Ticket”</b> para confirmar.",
            },
            side: "left",
            align: "start",
          },
          {
            popover: {
              itle: "📜 Revisa tus tickets antes de pagar",
              description:
                "Cada vez que agregues una apuesta con el signo <b>+</b>, puedes ver tu ticket haciendo scroll hacia arriba.<br/><br/><b>💡 ¡Puedes colocar todos los tickets que quieras antes de pagar!</b>",
            },
          },
          {
            element: ".buy-tour-step-1",
            popover: {
              title: "⚡Auto",
              description: `<b>¿Quieres jugar rápido y a tu manera?</b><br/>En la sección Auto puedes colocar cualquier combinación:<br/><br/><ul><li><b>Escribes 11</b> ➜ se convierte en Quiniela</li><li><b>Escribes 10-20</b> ➜ se convierte en Palé</li><li><b>Escribes 10-20-30</b> ➜ se convierte en Tripleta</li></ul><br/>¡Fácil, directo y a tu estilo! 😎`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".buy-tour-step-2",
            popover: {
              title: "➕ Coloca tu jugada y paga tu ticket",
              description: `Una vez que tengas tu combinación lista:<br/><br/><ol><li>Presiona el botón <b>“+”</b> para añadir tu jugada</li><li>Si estás listo, haz clic en <b>“Pagar Ticket”</b> más abajo</li></ol><br/>🎟️ ¡Así de simple!`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".buy-tour-step-3",
            popover: {
              title: "🔢 ¿Qué es una Quiniela?",
              description: `La Quiniela es una jugada de 1 solo número (2 dígitos).¡Puedes ganar si aciertas el 1er, 2do o 3er lugar del sorteo!<br/><br/><a href="#" class="btn-tour">Ver tutorial</a><br/><b>💰 Mientras más alto el lugar, mayor el premio.</b>`,
              side: "left",
              align: "start",
            },
          },
          ...(this.getFormLotteriesIsSuperquinielaEnabled
            ? [
                {
                  element: ".buy-tour-step-4",
                  popover: {
                    title: "🥇 ¿Qué es una Súper Quiniela?",
                    description: `La Súper Quiniela es una jugada especial de 1 solo número (2 dígitos).<br/>pero solo participas por el <b>primer lugar del sorteo.</b><br/><br/>🎯 ¡Es el premio mayor!`,
                    side: "left",
                    align: "start",
                  },
                },
              ]
            : []),
          {
            element: ".buy-tour-step-5",
            popover: {
              title: "🎯 ¿Qué es un Palé?",
              description: `<b>El Palé es una combinación de 2 números.</b><br/>Ganas si ambos números salen entre los primeros tres lugares en el mismo sorteo, en cualquier orden.<br/><br/><a href="#" class="btn-tour">Ver tutorial</a><br/><b>💥 ¡Mayor riesgo, mayor premio!</b>`,
              side: "left",
              align: "start",
            },
          },
          {
            element: ".buy-tour-step-6",
            popover: {
              title: "🎰 ¿Qué es una Tripleta?",
              description: `<b>La Tripleta es una jugada con 3 números.</b><br/>Ganas si los 3 números salen entre los primeros lugares del sorteo, sin importar el orden.<br/><br/><a href="#" class="btn-tour">Ver tutorial</a><br/><b>🏆 ¡Más difícil, pero con un premio mucho más grande!</b>`,
              side: "left",
              align: "start",
            },
          },
          {
            popover: {
              title: "👀 Visualiza tu ticket antes de pagarlo",
              description:
                "Antes de confirmar tu jugada, podrás ver tu <b>ticket completo</b> al final de la página, justo debajo del botón <b>“Pagar Ticket”</b>.<br/><br/><b>✅ Revisa que todo esté correcto antes de confirmar</b><br/><br/><b>🛒 ¡Así juegas con seguridad y confianza!</b>",
            },
          },
          {
            element: ".buy-tour-step-7",
            popover: {
              title: "💥 ¿Qué es un Súper Palé?",
              description: `El <b>Súper Palé</b> es una combinación de 2 números de 2 dígitos, pero a diferencia del Palé tradicional, aquí participas con una <b>lotería nacional + una lotería internacional</b> (por ejemplo: Nacional + New York).<br/><br/>🎯 Ganas si ambos números caen en el primer lugar de cada una.<br/><br/><a href="#" class="btn-tour">Ver tutorial</a><br/><b>📈 ¡Mayor dificultad, pero también un premio más alto!</b>`,
              side: "left",
              align: "start",
            },
          },
          {
            popover: {
              title: `<img class="tour-image" src="${tour3}"/>🎉 ¡Listo, ${
                firstname || ""
              } ${lastname || ""}!`,
              description: `<b>Recuerda:</b><br/>✅ Depósita antes de jugar<br/>➕ Usa el botón “+” para agregar jugadas<br/>👀 Puedes revisar tus tickets antes de pagarlos<br/>🎯 Aprovecha nuestras combinaciones y promociones<br/><br/><b>🌟 ¡Que la suerte esté de tu lado!</b><br/><br/><a href="#" class="btn-tour">Ver tutorial</a>`,
            },
          },
        ],
        onDestroyStarted: () => {
          if (!driverObj.hasNextStep() && !settings?.buyTourViewed) {
            try {
              this.updateSettings({
                ...settings,
                buyTourViewed: true,
              });
            } catch (error) {
              console.error("Error updating settings:", error);
            } finally {
              driverObj.destroy();
            }
          } else {
            driverObj.destroy();
          }
        },
      });

      driverObj.drive();
    },
    async openStatsModal() {
      await this.$refs.lotteries?.onSearch("");
      this.$nextTick(() => {
        this.showStats = true;
      });
    },
  },
  created() {
    const paramsRoute = this.$route.query;
    if (paramsRoute.d) {
      this.decodeParam(paramsRoute.d);
    }
  },
  watch: {
    superPaleGenerated: {
      immediate: true,
      handler(newValue = false, oldValue = false) {
        if (newValue !== oldValue) {
          this.playTypeFilter = newValue ? PLAY_TYPES.PALE : PLAY_TYPES.AUTO;
          this.form.numbers = "";
        }
      },
    },
    "form.lotteries": {
      handler(newVal) {
        if (newVal.filter((val) => val && "id" in val).length === 1) {
          this.form.isSuperpale = false;
        }
      },
      deep: true,
    },
    "$route.query.rebuy": {
      handler: function (value, oldValue) {
        if (value && value !== oldValue) {
          this.processQuery(value);
        }
      },
      immediate: true,
    },
    "$route.query.shared": {
      handler: function (value) {
        if (value) {
          this.processShared(value);
        }
      },
      immediate: true,
    },
    loggedUser: {
      handler: function (val, old) {
        if (
          val &&
          !isEqual(val, old) &&
          !this.loggedUser.settings?.buyTourViewed &&
          !this.isGettingLoggedUser &&
          this.isHelperEnable
        )
          this.handleBuyTour();
      },
      immediate: true,
      deep: true,
    },
    isHelperEnable: {
      handler: function (val, old) {
        if (
          this.isHelperEnable &&
          val != old &&
          !this.loggedUser.settings?.buyTourViewed
        )
          this.handleBuyTour();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.buy {
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  max-width: 100% !important;
  .content-base {
    margin-top: 12px;
    padding-top: 42px;
    padding-bottom: 42px;
    border-radius: 8px;
    border: 1px solid var(--card-shop-shadow);
    background-color: var(--card-shop-bg);
    @media screen and (max-width: $screen-mobile) {
      margin-top: 14px;
      max-width: calc(100% - 1.5rem) !important;
      margin-left: 0.75rem;
      margin-right: 0.75rem;
    }
    .action-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      &-date {
        color: var(--text);
        font-size: 14px;
        user-select: none;
        &-label {
          font-weight: 600;
          margin-right: 5px;
        }
        &-text {
          font-weight: 400;
          border-bottom: 1px solid var(--text);
        }
      }
      &-ticket-list {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        border-radius: 0;
        font-weight: 600;
      }
      &-stats {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        border-radius: 0;
        font-weight: 600;
        margin-left: 10px;
      }
      &-clear {
        margin-top: 1.5rem;
        border-radius: 0;
        color: var(--text);
      }
      &-pay {
        margin-top: 1.5rem;
        margin-left: 10px;
        color: var(--btn-text-primary);
        border-color: var(--btn-bc-primary);
        background-color: var(--btn-bg-primary);
        border-radius: 0;
        &:active,
        &:focus,
        &:hover {
          color: var(--btn-text-primary);
          border-color: var(--btn-bc-primary);
          background-color: var(--btn-bg-primary);
        }
      }
      @media screen and (max-width: $screen-mobile) {
        flex-direction: column-reverse;
        align-items: flex-start;
        row-gap: 15px;
      }
    }
    .totals-card {
      background-color: var(--card-bg);
      border: 1px solid var(--card-shadow);
      border-radius: 8px;
      .totals {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        &-item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &-label {
            font-size: 16px;
            font-weight: 600;
            color: var(--text);
            margin-right: 5px;
          }
          &-value {
            font-size: 16px;
            font-weight: 600;
            color: var(--text);
          }
        }
      }
    }
  }
  ::v-deep .ant-select-selection__choice__content {
    .avatar {
      display: none;
    }
    .text-container {
      width: 100%;
      .text-muted {
        display: none;
      }
    }
  }
  ::v-deep .ant-form-item-label label {
    font-weight: 500;
    font-size: 18px;
    color: var(--text) !important;
  }
  ::v-deep .ant-select-lg .ant-select-selection--multiple {
    background-color: var(--input-bg);
    .ant-select-selection__choice {
      background-color: var(--input-bg);
      border-color: var(--text-muted) !important;
      color: var(--text);
      .anticon-close {
        color: var(--text);
      }
    }
  }

  .action-is-mix,
  .action-is-superpale {
    color: var(--text);
    font-size: 15px;
    font-weight: 500;
    user-select: none;
    display: flex;
    align-items: center;
    margin-top: 6px;
    .ant-switch {
      background-color: var(--muted);
      border-color: var(--muted);
      &-checked {
        background-color: var(--switch-bg);
        border-color: var(--switch-bc);
      }
    }
  }
  .play-type-filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &.mini {
      max-width: 100%;
      overflow-x: auto;
      padding: 10px 0;
    }
    .custom-radio-button {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .ant-radio-button-wrapper {
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        color: var(--btn-text-secondary);
        &:before {
          background: none;
        }
        &:hover {
          border-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
          color: var(--btn-text-secondary);
        }
        &.ant-radio-button-wrapper-checked {
          border-color: var(--btn-bc-primary);
          background-color: var(--btn-bg-primary);
          color: var(--btn-text-primary);
        }
        &.superquiniela {
          width: 136px;
        }
      }
    }

    .popover-question {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: var(--btn-bg-primary);
      color: var(--btn-text-primary);
      margin-left: 10px;
    }
  }
  .custom-icon-info {
    position: absolute;
    right: 2px;
    top: 2px;
  }
  .jackpot-component-container {
    padding-right: 0 !important;
    padding-left: 0 !important;
    @media screen and (max-width: $screen-mobile) {
      padding-right: 0.75rem !important;
      padding-left: 0.75rem !important;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.ant-select-dropdown {
  background-color: var(--input-bg) !important;
  .ant-select-dropdown-menu-item {
    color: var(--text) !important;
    &-selected,
    &-active {
      background-color: var(--table-striped) !important;
    }
    &-selected {
      .anticon-check {
        color: var(--text) !important;
      }
    }
  }
  .text-danger {
    color: var(--danger) !important;
  }
}

.ant-table {
  font-size: 13px !important;
  &:hover {
    transition: 0.5s ease;
    background: unset;
  }
  tr.ant-table-row:hover {
    transition: 0.5s ease;
    background: var(--table-hover) !important;
  }
  tr:nth-child(2n) {
    transition: 0.5s ease;
    background: var(--table-striped) !important;
  }
  tr.marked {
    color: var(--text);
    background: var(--danger-lighter) !important;
    font-weight: 600;
  }
  tr.table-row-disabled,
  tr.table-row-disabled:hover {
    color: var(--table-disabled) !important;
    background: var(--table-disabled) !important;
    font-weight: 600;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    transition: 0.5s ease;
    background: none !important;
  }
  &-tbody,
  &-thead {
    color: var(--text) !important;
    tr {
      th {
        color: var(--text) !important;
        background-color: transparent !important;
      }
    }
  }
  &-footer {
    background: transparent;
  }
  @media screen and (max-width: $screen-mobile) {
    &-small {
      border: none;
    }
    &-body {
      margin: 0 1px;
    }
  }
}

.success-payment-modal {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
    }
    .ant-modal-confirm-btns {
      .ant-btn {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        &:hover,
        &:focus,
        &:active {
          color: var(--btn-text-secondary);
          border-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
        }
        &.ant-btn-primary {
          color: var(--btn-text-primary);
          border-color: var(--btn-bc-primary);
          background-color: var(--btn-bg-primary);
          &:hover {
            color: var(--btn-text-primary);
            border-color: var(--btn-bc-primary);
            background-color: var(--btn-bg-primary);
          }
        }
      }
    }
  }
}

.popover-keyboard {
  .ant-popover-inner {
    background: var(--card-bg) !important;
    background-color: var(--card-bg) !important;
  }

  .ant-popover-arrow {
    border-right-color: var(--card-shadow) !important;
    border-bottom-color: var(--card-shadow) !important;
  }

  .popover-pale,
  .popover-tripleta,
  .popover-multiple {
    padding: 0.5rem 0.8rem !important;
    cursor: pointer !important;
    font-size: 20px !important;
    text-transform: uppercase !important;
    border-radius: 5;
    color: var(--text);

    &:hover {
      background: var(--card-shadow) !important;
    }
  }
}

.ant-select {
  color: var(--text) !important;
}

/* Tabs */
.card-container p {
  margin: 0;
}
.card-container > .ant-tabs-card .ant-tabs-content {
  margin-top: -16px;
}
.card-container > .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
  padding: 16px;
  background: transparent;
  color: var(--text);
}
.card-container > .ant-tabs-card > .ant-tabs-nav::before {
  display: none;
}

.card-container {
  .ant-tabs-card {
    .ant-tabs-tab {
      background: var(--btn-bg-secondary) !important;
      border-color: var(--btn-bc-secondary) !important;
      color: var(--btn-text-secondary) !important;

      &.ant-tabs-tab-active {
        background: var(--btn-text-secondary) !important;
        border-color: var(--btn-bc-secondary) !important;
        color: var(--btn-bg-secondary) !important;
      }

      &:hover {
        background: var(--btn-text-secondary) !important;
        border-color: var(--btn-bc-secondary) !important;
        color: var(--btn-bg-secondary) !important;
      }
    }
  }
}

// New version
.playing {
  .background-button-buy {
    background-color: var(--red) !important;
  }
  .ant-tabs-nav {
    .ant-tabs-tab-active {
      background-color: var(--btn-bg-secondary);
      color: var(--btn-text-secondary) !important;
    }
  }
  .ant-tabs-nav {
    display: flex;
    justify-content: space-between;
  }
  .date-form {
    text-align: center;
  }

  .form-title-text {
    @media screen and (max-width: $screen-mobile) {
      padding-left: 0px;
      text-align: center;
      margin-bottom: 15px;
    }
  }

  .form-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 10px;
    display: block;
    text-align: left;
  }

  .note {
    text-align: left;
  }

  .prize-of-pick {
    margin-top: 10px;
    color: var(--text);
    text-align: left;
    .ant-radio-wrapper {
      color: var(--text);
    }
    .danger-error {
      color: red;
    }

    .ant-radio-checked {
      border-color: var(--btn-bc-primary);
      .ant-radio-inner {
        background-color: var(--btn-bc-primary);
        border-color: var(--btn-bc-primary);
        &::after {
          background-color: var(--btn-text-primary);
        }
      }
    }
  }

  .display-block-mobile {
    @media screen and (max-width: $screen-mobile) {
      display: contents;
      margin-bottom: 30px;
    }
  }

  .display-flex-mobile {
    @media screen and (max-width: $screen-mobile) {
      display: -webkit-box;
      margin-bottom: 0px !important;
    }
  }

  .keyboard-container {
    width: 100%;
    padding: 0 0;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .key-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 5px;
    width: 100%;
  }

  .k-btn {
    color: var(--btn-text-secondary);
    border: 1px solid var(--btn-bc-secondary);
    background: var(--btn-bg-secondary);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    cursor: pointer;
    font-size: 20px;
    @media screen and (max-width: $screen-mobile) {
      padding: 10px 0px;
      font-size: 15px;
    }

    &:active,
    &:hover {
      color: var(--btn-bg-secondary);
      border: 1px solid var(--btn-bc-secondary);
      background: var(--btn-text-secondary);
    }

    &:active {
      transform: scale(0.98);
    }
  }

  .special-k-btn {
    color: var(--btn-text-primary);
    border: 1px solid var(--btn-bc-primary);
    background: var(--btn-bg-primary);
    &:active,
    &:hover {
      color: var(--btn-text-primary);
      border: 1px solid var(--btn-bc-primary);
      background: var(--btn-bg-primary);
    }
  }

  input {
    &.ant-input {
      color: var(--text);
      background: var(--input-bg) !important;
      font-size: 22px !important;
      text-align: center !important;
      border-radius: 0;
      @media screen and (max-width: $screen-mobile) {
        font-size: 16px !important;
      }
    }
  }

  .ant-input-suffix {
    i {
      color: var(--text);
    }
  }

  .input-play {
    input.ant-input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .input-amount {
    input.ant-input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
.form-rotate {
  transform: rotate(-180deg);
}
.background-button {
  background-color: var(--success) !important;
}

@media screen and (max-width: $screen-mobile) {
  .display-block-mobile {
    display: contents;
  }
  .form-input-amount {
    width: 40%;
  }
  .form-right {
    padding-right: 10px;
  }
  .form-left {
    padding-left: 10px;
  }
  .with-row {
    max-width: 300px;
  }
}

.font-title-lotto {
  font-size: 20px;
  @media screen and (max-width: $screen-mobile) {
    font-size: 16px;
  }
}
.text-color-grey {
  color: var(--text-muted) !important;
}
.height-list {
  height: 450px !important;
  margin-bottom: 10px;
  @media screen and (max-width: $screen-mobile) {
    height: 200px !important;
    overflow: scroll;
    margin-bottom: 10px;
  }
}
.form-display-1 {
  display: flow-root;
  @media screen and (max-width: $screen-mobile) {
    display: contents !important;
  }
}

.modal-amount {
  .ant-modal {
    .ant-modal-content {
      background-color: var(--modal-bg);

      .ant-modal-header {
        background-color: var(--modal-bg);
        color: var(--text);

        .ant-modal-title {
          color: var(--text) !important;
        }
      }

      .ant-modal-close-x {
        .anticon {
          color: var(--text) !important;
        }
      }

      input {
        background: var(--input-bg) !important;
        color: var(--text);
        border: 1px solid var(--text-muted);
      }

      .anticon-close-circle {
        color: var(--text) !important;
      }

      .ant-modal-footer {
        .ant-btn {
          background: var(--btn-bg-secondary);
          color: var(--btn-text-secondary);
          border: 1px solid var(--btn-bc-secondary);

          &-primary {
            background: var(--btn-bg-secondary);
            color: var(--btn-text-secondary);
            border: 1px solid var(--btn-bc-secondary);
          }
        }
      }
    }
  }
}

.buy-tour-btn {
  position: fixed;
  bottom: 100px;
  right: 32px;
  font-size: 40px;
  color: var(--text);
  cursor: pointer;
  z-index: 1000;
  transition: color 0.3s ease;
  @media (max-width: $screen-mobile) {
    bottom: 80px;
    right: 25px;
  }
}
</style>
